module.exports = __webpack_public_path__ + "static/ICONS_COMMON_SVG-28-43ec10006b685e32503a44b0e95416ce.svg";